import { ReportResponseTypes } from '@mode/shared/data-access-webapp';

// TODO: move to more appropriate place
export const DefaultThemes: Array<string> = ['Mode Dark', 'Mode Grey', 'Mode Light', 'Mode Subway'];

export type RawTheme = [string, number];

export interface ReportTheme {
  id: number;
  name: string;
}

function toReportTheme(raw: RawTheme): { id: number; name: string } {
  return {
    id: raw[1],
    name: raw[0],
  };
}

function isDefaultTheme(raw: RawTheme): boolean {
  return DefaultThemes.includes(raw[0]);
}

function isCustomTheme(raw: RawTheme): boolean {
  return !DefaultThemes.includes(raw[0]);
}

// TODO: move to more appropriate place
export function getDefaultThemes(resource: ReportResponseTypes.ReportResource): ReportTheme[] {
  const _forms: any = resource._forms;
  return _forms.update_settings._inputs.report.theme.options.filter(isDefaultTheme).map(toReportTheme);
}

// TODO: move to more appropriate place
export function getCustomThemes(resource: ReportResponseTypes.ReportResource): ReportTheme[] {
  const _forms: any = resource._forms;
  return _forms.update_settings._inputs.report.theme.options.filter(isCustomTheme).map(toReportTheme);
}

export function getCurrentThemeID(resource: ReportResponseTypes.ReportResource): number {
  const _forms: any = resource._forms;
  return _forms.update_settings._inputs.report.theme.value;
}

export enum ReportEvents {
  ReportSaved = 'report_saved',
  AutoPinnedDataSourceTables = 'auto_pinned_data_source_tables',
}
